module.exports = __webpack_public_path__ + "img/clothing.b3ba1378.jpg";